export enum LinkType {
  Arrow = 'Arrow',
  Document = 'Document',
  Download = 'Download',
}
